const beats = beat => beat*300;

export default beats;